import type { QueryClient } from '@tanstack/react-query'
import { apiFetch } from '../api/http'
import { tokenStore } from './tokenStore'

export async function logout(queryClient: QueryClient): Promise<void> {
  try {
    await apiFetch<void>('/auth/logout', { method: 'POST', auth: false })
  } catch {
    /* cookie may already be gone */
  }
  tokenStore.clear()
  queryClient.clear()
}
